import React from 'react';
import {BrowserRouter, Route } from 'react-router-dom';
import OrgWidget from './Widgets/OrgPicks';
import HorseRaceWidget from './Widgets/HorseRaceWidget';


function App() {
  return (
    <BrowserRouter>
      <Route exact path='/orgpicks/:sport?/:event?/:org?' component={OrgWidget} />
      <Route exact path='/event/:raceName' component={HorseRaceWidget} />
    </BrowserRouter>
  )
}

export default App;
